import translator from '../../../application/Translator';
import util from '../../../application/Util';

'use strict';

/**
 * Tag directive.
 *
 * @class ngTranslate
 * @module Directives
 * @static
 */
class TranslateDirective {
    restrict = 'AE';
    scope = {
        translate: '=',
        translateParams: '=?'
    };

    link($scope, $element, $attrs) {
        let key = $scope.translate || $attrs['key'] || $element.html();

        if (translator.has(key)) {
            let trlUnbinder = null;

            if (!!$scope.translateParams) {
                $scope.$watch('translateParams', (newPars)=> {
                    let validArgs = _.reduce(newPars, (memo, arg)=> arg !== null && memo === true, true);
                    if (validArgs) {
                        let args = [key];
                        $scope.translateParams.forEach(p=>args.push(p));

                        try {
                            $element.html(translator.translate.apply(translator, args));
                        } catch (e) {
                            util.noop(e);
                        }

                        // unbind the binding from previous watch trigger
                        if (!!trlUnbinder) trlUnbinder.unbind();
                        trlUnbinder = translator.bind(translator.Event.LANGUAGE_CHANGED, ()=> $element.html(translator.translate.apply(translator, args)));
                    }
                });
            } else {
                $element.html(translator.translate(key));
                trlUnbinder = translator.bind(translator.Event.LANGUAGE_CHANGED, () => $element.html(translator.translate(key)));
            }
            $scope.$on('destroy', () => trlUnbinder.unbind());
        } else {
            $element.html('X:' + key);
        }
    }
}

export default () => new TranslateDirective();


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/decorator/translate.directive.js